<div *ngIf="loading" class="portal-loading" role="status">Loading account information…<mat-progress-bar mode="indeterminate" aria-label="Loading account information"></mat-progress-bar></div>
<section *ngIf="!loading" class="portal-account-details" aria-labelledby="account-title">
  <h1 id="account-title" class="portal-page-title">Account information</h1>
  <mat-card><mat-card-content><dl class="portal-details">
    <dt>Account name</dt><dd>{{username}}</dd>
    <dt>Email address</dt><dd>{{email}}</dd>
  </dl></mat-card-content></mat-card>
  <mat-card *ngIf="roles != null && roles.length > 0"><mat-card-content>
    <h2 class="portal-section-title">Roles</h2><ul><li *ngFor="let role of roles">{{role}}</li></ul>
  </mat-card-content></mat-card>
</section>
